module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/148h4nO/tc-custom/9781504094870.jpg?1725419921899",
      "alt": "This image is the cover for the book Company She Keeps"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Company She Keeps\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A spine-tingling suspense thriller that asks: How many bad men can one woman have in her life? ")]), _c('br'), _c('br'), _c('i', [_vm._v("England, 1979")]), _vm._v(". After a childhood trauma, Rebecca struggles to build healthy relationships. Her on-again-off-again partner is a married police officer trying to catch the Yorkshire Ripper, who has just claimed his tenth victim."), _c('br'), _c('br'), _vm._v(" Then Rebecca meets Larry, a charming American with a troubled past."), _c('br'), _c('br'), _vm._v(" And of course there’s Mervyn, the creepy journalist she ended a brief relationship with, who will do anything to keep her in his life . . ."), _c('br'), _c('br'), _vm._v(" With three very different men craving her attention, and a serial killer on the loose, Rebecca soon finds herself in a twisted game of cat and mouse. Can any of these men be trusted? And could one of them in fact be a cold-blooded killer?\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      James Woolf\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Bloodhound Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0